import { AccountsAPI } from "./axios.config";

export const getBankRecNominals = () =>
  AccountsAPI.get(`/nominals?banks=true&Orderby=subType,nominalRef`);

export const getNominalsByRef = (nominalRef) =>
  AccountsAPI.get(`/nominals/Ref/${nominalRef}`);

export const getactivenominals = () =>
  AccountsAPI.get(`/nominals?archived=false&active=true`);

export const getActiveIncomeNominals = () =>
  AccountsAPI.get(`/nominals?banks=false&Orderby=subType,nominalRef`);

export const getBankTransferNominals = () =>
  AccountsAPI.get(
    `/nominals?subType=BalanceSheet_OfficeBank&active=true&Orderby=subType,nominalRef`
  );

export const getIncomeNominals = () =>
  AccountsAPI.get(
    "/nominals?archived=false&active=true&subtype=ProfitAndLoss_Income"
  );

export const getBillRequestsList = (page, limit, parameter) =>
  AccountsAPI.get(`/BillRequest?${parameter}&page=${page}&limit=${limit}`);

export const getNominalsByType = (type) =>
  AccountsAPI.get(`/nominals?type=${type}&active=true`);

export const getNominalJournalPosting = () =>
  AccountsAPI.get(`/nominals?archived=false&controlNominal=false`);

export const editPosting = (transactionNo, data) =>
  AccountsAPI.patch(`/postings/${transactionNo}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const reversePosting = (transactionNo, data) =>
  AccountsAPI.request({
    url: `/postings/${transactionNo}`,
    method: "DELETE",
    data: JSON.stringify({ data }),
    headers: { "Content-Type": "application/json" },
  });

export const getCurrentSessionTransactionPeriod = (sessionPeriod) =>
  AccountsAPI.get(`/TransactionPeriods/Current?sessionPeriod=${sessionPeriod}`);

export const getDefaultNominals = (branchId) =>
  AccountsAPI.get(`/DefaultNominal/${branchId}`);

export const getNewDefaultNominals = (branchId) =>
  AccountsAPI.get(`/DefaultNominal/${branchId}/New`);

export const getAuthorizations = () => AccountsAPI.get(`/Authorisations`);

export const updateAuthoriations = (data) =>
  AccountsAPI.patch(`/Authorisations`, JSON.stringify({ data: data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateDefaultNominals = (branchId, data) =>
  AccountsAPI.post(`/DefaultNominal/${branchId}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const getReportTemplates = (type) =>
  AccountsAPI.get(`/ReportTemplates?reportType=${type}`);

export const addReportTemplate = (data, type) =>
  AccountsAPI.post(
    `/ReportTemplates?reportType=${type}`,
    JSON.stringify({ data }),
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const editReportTemplate = (data, type, id) =>
  AccountsAPI.patch(
    `/ReportTemplates/${id}?reportType=${type}`,
    JSON.stringify({ data }),
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const getPreviousTransactions = (
  matterId,
  nominalRef,
  supplierRef,
  page = 1,
  limit = 200
) => {
  let url = `/PreviousTransactions?`;

  url += `page=${page}&limit=${limit}`;

  if (matterId) {
    url += `&MatterID=${matterId}`;
  }
  if (nominalRef) {
    url += `&nominalRef=${nominalRef}`;
  }
  if (supplierRef) {
    url += `&supplierRef=${supplierRef}`;
  }

  return AccountsAPI.get(url);
};

export const getChartOfAccounts = () => AccountsAPI.get(`/ChartOfAccounts`);

export const createChartOfAccounts = (data) =>
  AccountsAPI.post(`/ChartOfAccounts`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateChartOfAccounts = (id, data) =>
  AccountsAPI.patch(`/ChartOfAccounts/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getChartOfAccountBalance = (type) =>
  AccountsAPI.get(
    `/ChartOfAccounts?type=${type}&active=true&fields=chartOfAccountId,name,type&orderby=name`
  );

export const getBankRecData = (nominlaId, reconcile) =>
  AccountsAPI.get(`/bankrec/${nominlaId}?todate=${reconcile}`);

export const addBankRecs = (nominalRef, data) =>
  AccountsAPI.post(`/bankrec/${nominalRef}/save`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const postBankRecs = (nominalRef, data) =>
  AccountsAPI.post(`/bankrec/${nominalRef}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const getBillingRequestDetails = (id) =>
  AccountsAPI.get(`/BillRequest/${id}`);

export const AuthorizeChits = (data) =>
  AccountsAPI.post(`/Chits/Authorise`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getBankRec = (subtype) => {
  const url = subtype
    ? `/BankRec?active=true&subtype=${subtype}`
    : `/BankRec?active=true`;
  return AccountsAPI.get(url);
};

export const getactiveVats = () => AccountsAPI.get(`/VatCodes?active=true`);

export const getVatcodes = (page, limit) =>
  AccountsAPI.get(`/VatCodes?page=${page}&limit=${limit}`);

export const addnewVat = (data) =>
  AccountsAPI.post(`/VatCodes`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editVatinfo = (id, data) =>
  AccountsAPI.patch(`/VatCodes/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const createposting = (data, options = {}) => {
  const { allowOverdrawn = false, authcode } = options;
  let url = `/Postings`;
  const qp = [];
  if (allowOverdrawn) qp.push(`allowOverdrawn=true`);
  if (authcode) qp.push(`authcode=${encodeURIComponent(authcode)}`);
  if (qp.length) url += `?${qp.join("&")}`;
  return AccountsAPI.post(url, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
};

export const createBillingRequest = (data) =>
  AccountsAPI.post(`/BillRequest`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const rejectBillingReqeust = (id) =>
  AccountsAPI.post(`/BillRequest/${id}/Reject`, {
    headers: { "Content-Type": "application/json" },
  });

export const createChitRequest = (data) =>
  AccountsAPI.post(`/Chits`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getChitRequest = (id) => AccountsAPI.get(`/Chits/${id}`);

export const updateChitRequest = (id, data) =>
  AccountsAPI.patch(`/Chits/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json-patch+json" },
  });

export const getChitDocuments = (chitId) =>
  AccountsAPI.get(`/Chits/${chitId}/Documents`);

export const rejectChitRequest = (id, data) =>
  AccountsAPI.patch(`/Chits/${id}/Reject`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const getConsultantRefs = () =>
  AccountsAPI.get(`/Suppliers?type=Consultant&active=true`);

export const getChitPostingList = (page, limit, parameter, orderby) => {
  let url = `/Chits?page=${page}&limit=${limit}`;

  if (parameter) {
    url += `&${parameter}`;
  }

  if (orderby) {
    url += `&orderby=${orderby}`;
  }

  return AccountsAPI.get(url);
};

export const getDisbursementMatterList = (matterId) =>
  AccountsAPI.get(`/Postings/Matters/${matterId}/UnpaidDisb`);

export const getPaySupplierList = (supplierId, transactionType, type) => {
  let url = `/Postings/Supplier/${supplierId}/UnpaidDisb`;
  const queryParams = new URLSearchParams();

  if (transactionType) {
    queryParams.append("transactiontype", transactionType);
  }
  if (type) {
    queryParams.append("type", type);
  }

  const qs = queryParams.toString();
  if (qs) {
    url += `?${qs}`;
  }

  return AccountsAPI.get(url);
};

export const getMatterDisbRecords = (matterId) =>
  AccountsAPI.get(
    `/Postings/Matters/${matterId}/UnbilledDisb?billed=false&InBillRequest=false`
  );

export const getPostingDocuments = (transcNo) =>
  AccountsAPI.get(`/Postings/${transcNo}/Documents`);

export const getDashboardDebtorsData = (
  teamId,
  feeEarnerRef,
  branchId,
  fromDate,
  toDate
) => {
  let url = `/Dashboard/Debtors?`;
  const parameters = constructApiQuery(
    branchId || null,
    teamId || null,
    feeEarnerRef || null
  );

  if (fromDate) {
    url += `&FromDate=${fromDate}`;
  }
  if (toDate) {
    url += `&ToDate=${toDate}`;
  }

  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  return AccountsAPI.get(url);
};

export const getDashboardCreditorsData = (
  teamId,
  feeEarnerRef,
  branchId,
  fromDate,
  toDate
) => {
  let url = `/Dashboard/Creditors?`;
  const parameters = constructApiQuery(
    branchId || null,
    teamId || null,
    feeEarnerRef || null
  );

  if (fromDate) {
    url += `&FromDate=${fromDate}`;
  }
  if (toDate) {
    url += `&ToDate=${toDate}`;
  }

  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  return AccountsAPI.get(url);
};

export const getDashboardBillingTargetData = (
  teamId,
  feeEarnerRef,
  branchId,
  fromDate,
  toDate
) => {
  let url = `/Dashboard/BillingTarget?`;
  const parameters = constructApiQuery(
    branchId || null,
    teamId || null,
    feeEarnerRef || null
  );

  if (fromDate) {
    url += `&FromDate=${fromDate}`;
  }
  if (toDate) {
    url += `&ToDate=${toDate}`;
  }

  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  return AccountsAPI.get(url);
};

export const importSampleChit = () => AccountsAPI.get(`/Chits/Import`);

export const getChitImportTypes = (active = true, orderby = "importerName") =>
  AccountsAPI.get(`/Chits/import/types?active=${active}&orderby=${orderby}`);

export const getChitImportData = (chitImporterId) =>
  AccountsAPI.get(`/Chits/import/data?chitImporterId=${chitImporterId}`);

export function constructApiQuery(branch, team, feeEarner) {
  let query = {};
  if (feeEarner && feeEarner !== "ALL") {
    query.FeeEarnerRef = feeEarner;
  } else if (team && team !== -2) {
    query.TeamID = team;
  } else if (branch && branch > 0) {
    query.BranchId = branch;
  }

  return query;
}

export const getCTOSweep = (page, limit, parameter, orderby) => {
  let url = `/CTOSweep?Page=${page}&Limit=${limit}`;
  if (parameter.billsOnly) {
    url += `&BillsOnly=${parameter.billsOnly}`;
  }
  if (parameter.includeRingfenced) {
    url += `&IncludeRingFenced=${parameter.includeRingfenced}`;
  }
  if (orderby) {
    url += `&OrderBy=${orderby}`;
  }
  return AccountsAPI.get(url);
};

export const postCTOSweep = (data) =>
  AccountsAPI.post(`/CTOSweep`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getLookups = (lookupType) =>
  AccountsAPI.get(`/Lookups/${lookupType}`);

export const getLookupById = (lookupType, id) =>
  AccountsAPI.get(`/Lookups/${lookupType}/${id}`);

export const createLookup = (lookupType, data) =>
  AccountsAPI.post(`/Lookups/${lookupType}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateLookup = (lookupType, id, data) =>
  AccountsAPI.patch(`/Lookups/${lookupType}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const searchPostings = (date, reference, limit = 1) => {
  let url = `/postings/search?`;
  const params = [];
  
  if (date) {
    params.push(`Date=${date}`);
  }
  if (reference) {
    params.push(`reference=${encodeURIComponent(reference)}`);
  }
  if (limit) {
    params.push(`limit=${limit}`);
  }
  
  url += params.join("&");
  return AccountsAPI.get(url);
};
